"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var styles_module_scss_1 = __importDefault(require("../styles.module.scss"));
var useValidationSchema_1 = require("./useValidationSchema");
var Step1 = function (_a) {
    var forgotPassword = _a.forgotPassword, error = _a.error, isSubmitting = _a.isSubmitting, withLabels = _a.withLabels;
    var t = (0, next_intl_1.useTranslations)('translation');
    var tErr = (0, next_intl_1.useTranslations)('errors');
    var validateSchema = (0, useValidationSchema_1.useValidateSchema)();
    var loginUrl = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.SIGN_IN_MODAL);
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        forgotPassword({ login: values.email });
    }, [forgotPassword]);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
        react_1.default.createElement(react_final_form_1.Form, { onSubmit: onSubmitHandler, validate: (0, apps_shared_1.formValidator)(validateSchema), render: function (_a) {
                var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement(react_final_form_1.Field, { name: "email", render: function (_a) {
                                var input = _a.input, meta = _a.meta;
                                return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                    react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: "light", placeholder: "user@gmail.com", labelText: withLabels ? t('email') : undefined, helperButton: meta.error && meta.touched && { type: 'error' } })),
                                    meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                            } }),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.mainErrorWrapper }, error && react_1.default.createElement(ui_components_1.ErrorText, null, tErr(error)))),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("br", null),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                            react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", loading: isSubmitting || submitting, text: "upper", width: "200px" }, t('resetPassword'))),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.centerLinkWrapper },
                            react_1.default.createElement(ui_components_1.TextLink, { href: loginUrl }, t('back'))))));
            } })));
};
exports.default = Step1;
